import { Col, Form, message, Row } from "antd";
import { AppPageHeader } from "components/AppPageHeader";
import { VendorForm } from "forms/VendorForm";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { submitVendorAmendment } from "store/vendor/vendorSlice";
import { getWarehouseId } from "services/PersistService/PersistWareHouseReturn";
import { routes } from "common/routes";

const MESSAGE_KEY = "new-vendor";

const NewVendorPage = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { amendmentStatus, amendmentError } = useAppSelector((state) => state.vendors);
  const navigate = useNavigate();

  useEffect(() => {
    if (amendmentStatus === "saving") {
      message.loading({ content: "Submitting request...", key: MESSAGE_KEY });
    } else if (amendmentStatus === "error" && amendmentError) {
      message.error({ content: amendmentError, key: MESSAGE_KEY });
    }
    return () => message.destroy();
  }, [amendmentStatus, amendmentError]);

  const onFinish = (values: Record<string, any>) => {
    const {
      address1, address2, city, state, pincode,
      accountNumber, accountName, gstin, bankName, ifscCode, branchName,
      cancelledChequeFileUrl, shopImageUrl, licenseFileUrl,
      gstCertificateFileUrl, panImageUrl, adhaarImageUrl,
      paymentMethod, market, parentVendorId,
      purchaseCodes, latitude, longitude,
      vendorEmail,
      ...rest
    } = values;

    const payload = {
      ...rest,
      vendorEmail: vendorEmail || null,
      address: { address1, address2, city, state, pincode },
      metadata: {
        gstin: gstin || null,
        bankAccountDetails: { accountNumber, accountName, bankName, ifscCode, branchName },
        market: market || null,
        paymentMethod: paymentMethod || null,
        cancelledChequeFileUrl: cancelledChequeFileUrl || null,
        shopImageUrl: shopImageUrl || null,
        licenseFileUrl: licenseFileUrl || null,
        gstCertificateFileUrl: gstCertificateFileUrl || null,
        panImageUrl: panImageUrl || null,
        adhaarImageUrl: adhaarImageUrl || null,
        // [{ purchaseSkuCode, reliabilityScore }] — shape per the amendments API contract
        purchaseCodes: Array.isArray(purchaseCodes) && purchaseCodes.length
          ? purchaseCodes.map((c: any) => ({ purchaseSkuCode: c.purchaseSkuCode, reliabilityScore: c.relibilityScore ?? c.reliabilityScore }))
          : null,
        parentVendorId: rest.vendorType === "CHILD" ? (parentVendorId || null) : null,
        latitude: latitude ?? null,
        longitude: longitude ?? null,
      },
      whId: getWarehouseId(),
    };

    dispatch(
      submitVendorAmendment({
        entityType: "VENDOR",
        requestType: "CREATE",
        payload,
      })
    )
      .unwrap()
      .then(() => {
        message.success({ content: "Vendor create request submitted for approval!", key: MESSAGE_KEY });
        navigate(`/${routes.VENDOR.AMENDMENTS}`);
      })
      .catch(() => {});
  };

  return (
    <>
      <Row>
        <Col>
          <AppPageHeader title="New Vendor" />
        </Col>
      </Row>
      <Row>
        <VendorForm
          formInstance={form}
          onFinish={onFinish}
          onCancel={() => navigate("/vendors")}
          onSubmit={() => form.submit()}
          loading={amendmentStatus === "saving"}
        />
      </Row>
    </>
  );
};

export default NewVendorPage;
